import { memo } from 'react';

const BusinessDetailMetaRow = memo(({ icon, children }) => (
  <div className="flex w-full items-center gap-business-result-row">
    <img src={icon} alt="" className="icon-sm shrink-0" aria-hidden="true" />
    <div className="min-w-0 flex-1 desktop:text-[16px] text-sm font-medium leading-4.5 desktop:leading-6 text-merchant-text-secondary">
      {children}
    </div>
  </div>
));

BusinessDetailMetaRow.displayName = 'BusinessDetailMetaRow';

export default BusinessDetailMetaRow;
